import * as ServiceNamespace from './services';

export const providers = [
  ServiceNamespace.AuthenticationService,
  ServiceNamespace.AlertService,
  ServiceNamespace.AssignorService,
  ServiceNamespace.ReportService,
  ServiceNamespace.BankService,
  ServiceNamespace.WebSocketService,
  ServiceNamespace.FileService,
  ServiceNamespace.ActivityBranchService,
  ServiceNamespace.LocalStorageService,
  ServiceNamespace.ReceivableService,
  ServiceNamespace.WalletService,
  ServiceNamespace.ConciliationExtractService
];
